import { Location } from 'history';
import { horizontalAppRoutes } from 'App/appRoutes';

export const isHorizontalTabRoute = (location: Location): boolean => {
	return horizontalAppRoutes.some(route =>
		location?.pathname?.startsWith(route.getUrl({}))
	);
};
